<div class="permissions-extras-container">
  <!-- Loading State -->
  @if ($loading()) {
  <div class="loading-container">
    <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
    <p class="loading-text">
      {{ 'FEATURE_PERMISSIONS.CARREGANDO' | translate }}
    </p>
  </div>
  }

  <!-- Conteúdo -->
  @if (!$loading()) {
  <div class="flex flex-column gap-4">
    <!-- Seção 1: Permissões Herdadas dos Planos (READONLY) -->
    <!-- <div class="surface-card p-4 shadow-2 border-round"> -->
    <!-- Header -->
    <!-- <div class="flex justify-content-between align-items-center mb-3">
        <div class="flex align-items-center">
          <i class="pi pi-shield text-2xl mr-2 text-primary"></i>
          <h3 class="m-0 text-lg font-semibold">
            {{ 'USER_PERMISSIONS_EXTRAS.HERDADAS_PLANO' | translate }}
          </h3>
        </div>
        <p-tag [value]="planPermissions().length.toString()" severity="info"></p-tag>
      </div> -->

    <!-- Empty State -->
    <!-- @if (planPermissions().length === 0) {
      <div
        class="flex flex-column align-items-center justify-content-center p-4 mt-4 border-1 surface-border border-round">
        <i class="pi pi-info-circle text-4xl text-color-secondary mb-3"></i>
        <span class="text-color-secondary">{{
          'USER_PERMISSIONS_EXTRAS.SEM_HERDADAS' | translate
          }}</span>
      </div>
      } @else { -->
    <!-- Grid Manual (sem DataView) -->
    <!-- <div class="grid">
        @for (permission of paginatedPlanPermissions(); track permission.id) {
        <div class="col-12 p-2 permission-grid-item-wrapper">
          <div class="p-2 border-1 surface-border border-round permission-grid-item">
            <div class="flex justify-content-between align-items-center gap-3">
              <div class="flex align-items-center flex-wrap gap-x-4 gap-y-1">
                <span class="permission-key font-bold">{{ permission.key }}</span>
                <p-tag [value]="permission.module" severity="secondary"></p-tag>
                <p-tag styleClass="inherited-tag" icon="pi pi-lock" value="Herdada"></p-tag>
                <p class="m-0 text-sm text-color-secondary">
                  {{ permission.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
        }
      </div> -->

    <!-- Paginação manual -->
    <!-- <p-paginator [rows]="rowsPerPagePlan()" [totalRecords]="planPermissions().length"
        [rowsPerPageOptions]="[6, 12, 24]" (onPageChange)="onPageChangePlan($event)"></p-paginator>
      } -->
    <!-- </div> -->

    <!-- Seção 2: Permissões Extras (REMOVÍVEIS) -->
    <div class="surface-card p-4 shadow-2 border-round">
      <!-- Header -->
      <div class="flex justify-content-between align-items-center mb-3">
        <div class="flex align-items-center">
          <i class="pi pi-plus-circle text-2xl mr-2 text-orange-500"></i>
          <h3 class="m-0 text-lg font-semibold">
            {{ 'USER_PERMISSIONS_EXTRAS.EXTRAS' | translate }}
          </h3>
        </div>
        <p-tag
          [value]="extraPermissions().length.toString()"
          severity="warning"
        ></p-tag>
      </div>

      <!-- Empty State -->
      @if (extraPermissions().length === 0) {
      <div
        class="flex flex-column align-items-center justify-content-center p-4 mt-4 border-1 surface-border border-round"
      >
        <i class="pi pi-info-circle text-4xl text-color-secondary mb-3"></i>
        <span class="text-color-secondary">{{
          'USER_PERMISSIONS_EXTRAS.SEM_EXTRAS' | translate
        }}</span>
      </div>
      } @else {
      <!-- Grid Manual (sem DataView) -->
      <div class="grid">
        @for (permission of paginatedExtraPermissions(); track permission.id) {
        <div class="col-12 p-2 permission-grid-item-wrapper">
          <div
            class="p-2 border-1 surface-border border-round permission-grid-item"
          >
            <div class="flex justify-content-between align-items-center gap-3">
              <div class="flex align-items-center flex-wrap gap-x-4 gap-y-1">
                <span class="permission-key font-bold">{{
                  permission.key
                }}</span>
                <p-tag [value]="permission.module" severity="secondary"></p-tag>
                @if (permission.priceMonthly) {
                <span class="font-semibold text-orange-500"
                  >{{ formatarPreco(permission.priceMonthly) }}/mês</span
                >
                }
                <p class="m-0 text-sm text-color-secondary">
                  {{ permission.description }}
                </p>
              </div>
              @if (canEdit) {
              <button
                pButton
                type="button"
                icon="pi pi-trash"
                class="p-button-rounded p-button-text p-button-sm p-button-danger flex-shrink-0"
                [pTooltip]="'USER_PERMISSIONS_EXTRAS.BTN_REMOVER' | translate"
                tooltipPosition="top"
                (click)="confirmarRemoverExtra(permission)"
              ></button>
              }
            </div>
          </div>
        </div>
        }
      </div>

      <!-- Paginação manual -->
      <p-paginator
        [rows]="rowsPerPageExtra()"
        [totalRecords]="extraPermissions().length"
        [rowsPerPageOptions]="[6, 12, 24]"
        (onPageChange)="onPageChangeExtra($event)"
      ></p-paginator>
      }
    </div>

    <!-- Seção 3: Adicionar Permissões Standalone (MULTISELECT) -->
    @if (canEdit) {
    <div class="surface-card p-4 shadow-2 border-round">
      <!-- Header -->
      <div class="flex justify-content-between align-items-center mb-3">
        <div class="flex align-items-center">
          <i class="pi pi-plus text-2xl mr-2 text-green-500"></i>
          <h3 class="m-0 text-lg font-semibold">
            {{ 'USER_PERMISSIONS_EXTRAS.ADICIONAR' | translate }}
          </h3>
        </div>
        @if (selectedPermissionsToAdd().length > 0) {
        <p-tag
          [value]="selectedPermissionsToAdd().length + ' selecionada(s)'"
          severity="success"
        ></p-tag>
        }
      </div>

      <!-- MultiSelect - Solução Responsiva -->
      <div class="field">
        <label for="extras-multiselect" class="font-semibold mb-2 block">
          {{ 'USER_PERMISSIONS_EXTRAS.DISPONIVEIS' | translate }}
        </label>
        @if (deviceService.$isMobile()) {
        <lib-n-multiselect
          id="extras-multiselect"
          [options]="availableStandalonePermissions()"
          [ngModel]="selectedPermissionsToAdd()"
          (ngModelChange)="selectedPermissionsToAdd.set($event)"
          optionLabel="key"
          placeholder="{{
            'USER_PERMISSIONS_EXTRAS.SELECIONE_PERMISSOES' | translate
          }}"
          [disabled]="
            $loading() || availableStandalonePermissions().length === 0
          "
          [showHeader]="true"
        />
        } @else {
        <p-multiSelect
          id="extras-multiselect"
          [options]="availableStandalonePermissions()"
          [ngModel]="selectedPermissionsToAdd()"
          (ngModelChange)="selectedPermissionsToAdd.set($event)"
          optionLabel="key"
          [filter]="true"
          filterBy="key,description,module"
          [showToggleAll]="true"
          [showHeader]="true"
          placeholder="{{
            'USER_PERMISSIONS_EXTRAS.SELECIONE_PERMISSOES' | translate
          }}"
          display="chip"
          [style]="{ width: '100%' }"
          [panelStyle]="{ minWidth: '100%' }"
          appendTo="body"
          [disabled]="
            $loading() || availableStandalonePermissions().length === 0
          "
        >
          <ng-template let-permission pTemplate="item">
            <div class="flex flex-column gap-1 py-2">
              <div class="flex align-items-center gap-2 flex-wrap">
                <i class="pi pi-shield text-primary"></i>
                <span class="font-semibold">{{ permission.key }}</span>
                <p-tag
                  [value]="permission.module"
                  [severity]="'info'"
                  styleClass="text-xs"
                ></p-tag>
                @if (permission.priceMonthly) {
                <span class="font-semibold text-green-600 text-sm"
                  >{{ formatarPreco(permission.priceMonthly) }}/mês</span
                >
                }
              </div>
              <span class="text-sm text-color-secondary ml-4">{{
                permission.description
              }}</span>
            </div>
          </ng-template>
          <ng-template pTemplate="selectedItem" let-permission>
            <div class="inline-flex align-items-center gap-2 px-1">
              <span class="text-sm">{{ permission.key }}</span>
            </div>
          </ng-template>
        </p-multiSelect>
        }

        <!-- Empty State -->
        @if (availableStandalonePermissions().length === 0) {
        <div class="mt-3 p-3 border-1 surface-border border-round text-center">
          <i class="pi pi-info-circle text-3xl text-color-secondary mb-2"></i>
          <p class="m-0 text-color-secondary">
            {{
              'USER_PERMISSIONS_EXTRAS.SEM_PERMISSOES_DISPONIVEIS' | translate
            }}
          </p>
        </div>
        }
      </div>

      <p-divider></p-divider>

      <!-- Footer Actions -->
      <div class="flex justify-content-between align-items-center">
        <span class="text-sm text-color-secondary">
          {{ availableStandalonePermissions().length }}
          {{ 'USER_PERMISSIONS_EXTRAS.PERMISSOES_DISPONIVEIS' | translate }}
        </span>
        <button
          pButton
          type="button"
          icon="pi pi-check"
          label="{{ 'USER_PERMISSIONS_EXTRAS.BTN_ADICIONAR' | translate }}"
          class="p-button-success"
          [disabled]="selectedPermissionsToAdd().length === 0 || $loading()"
          (click)="adicionarExtras()"
        ></button>
      </div>
    </div>
    }
  </div>
  }
</div>

<!-- Confirm Dialog -->
@if (canEdit) {
<p-confirmDialog></p-confirmDialog>
}
